// extracted by mini-css-extract-plugin
export const cardHeader = "typography-module--cardHeader--3AaZa";
export const smallCardHeader = "typography-module--smallCardHeader--1fIM1";
export const bigParagraph = "typography-module--bigParagraph--Ji1Jx";
export const mediumParagraph = "typography-module--mediumParagraph--2RgTM";
export const merriweather = "typography-module--merriweather--1Zq6A";